import React, { Component } from 'react';
import { __ } from '../Translator';
import AppActions from '../flux/AppActions';
import LanguageStore from '../flux/LanguageStore';
import Dropdown from '../components/Dropdown';
import './LanguageSelect.css';

class LanguageSelect extends Component {
  state = {
    language: LanguageStore.getState(),
  };

  subscriptions = [];

  componentDidMount() {
    this.subscriptions.push(LanguageStore.addListener(() => {
      this.setState({ language: LanguageStore.getState() });
    }));
  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  render() {

    return this.props.isStartPage ? (

      <div className="language__dropdown" style={{ fontSize: '80%', position:'fixed', zIndex: '1', width: '20rem', top:'18rem', left: '50%', transform: 'translate(-50%, -50%)' }}>
      <Dropdown
              selected={this.state.language || ''}
              options={[
                { value: "en", text: "English" },
                { value: "it", text: "Italiano" },
                { value: "fr", text: "Français" },
                { value: "de", text: "Deutsch" },
                { value: "es", text: "Español" },
              ]}
              onChange={lang => AppActions.updateLanguage(lang)}
      />
      </div>
    ) : (
      <select className={`language__select ${this.props.isStartPage ? `central` : `` } `} value={this.state.language} onChange={event => AppActions.updateLanguage(event.target.value)}>
        <option value="en">{'English'}</option>
        <option value="it">{'Italiano'}</option>
        <option value="fr">{'Français'}</option>
        <option value="de">{'Deutsch'}</option>
        <option value="es">{'Español'}</option>
      </select>
    )
  }
}

export default LanguageSelect;



// WEBPACK FOOTER //
// ./src/components/LanguageSelect.js